import { type ParsedUrlQuery } from 'querystring';
import { type UrlObject } from 'url';

import { getPopulatedMeta } from '@vakantiesnl/components/src/utils/search/useSearchMeta';
import { searchUrlBuilderOptions } from '@vakantiesnl/services/src/hooks/useSearchUrlBuilder';
import { type FilterState } from '@vakantiesnl/services/src/stores/filtersStore';
import type { GlobalFiltersState } from '@vakantiesnl/services/src/stores/globalFiltersStore/interfaces';

import { type CheckBox } from '../../molecules/CheckboxGroup';

export const formatHiddenSearchFilterLink = (
	{ name, value }: CheckBox,
	routerQuery: ParsedUrlQuery,
	globalFilters: GlobalFiltersState,
	filters?: FilterState,
): UrlObject | undefined => {
	if (!filters || !name || !value || !filters.hasOwnProperty(name)) {
		return;
	}

	const currentFilterValue = filters[name as keyof FilterState];

	/** Only build hidden hrefs for array or string filter values */
	if (Array.isArray(currentFilterValue) || typeof currentFilterValue === 'string') {
		const newFilterValue = !(currentFilterValue as string[]).includes(value)
			? [...currentFilterValue, value]
			: currentFilterValue;

		const filtersWithNewValue: FilterState = {
			...filters,
			[name]: newFilterValue,
			campaign: filters.campaign,
		};

		const meta = getPopulatedMeta(filtersWithNewValue, globalFilters);

		const { pathname } = searchUrlBuilderOptions(meta, routerQuery);

		/** We don't want crawling for pages to /zoeken */
		if (!pathname) return;

		return {
			pathname,
		};
	}
	return;
};
